/* NEO Liquid LP — page-shell behaviour (vanilla JS, no jQuery).
   All interaction is delegated at document level so it survives the theme
   editor / hot-reload re-rendering the section (which replaces the DOM). */
(function () {
  "use strict";

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }

  /* ---- Press carousel: N cards per view, auto-advance, swipe, dots ---- */
  var AUTOPLAY_MS = 5000;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function perView() {
    var w = window.innerWidth;
    return w <= 640 ? 1 : (w <= 1024 ? 2 : 3);
  }

  function carouselPages(root) {
    var slides = root.querySelectorAll(".neo-carousel__slide");
    return Math.max(1, Math.ceil(slides.length / perView()));
  }

  function carouselRender(root) {
    var track = root.querySelector(".neo-carousel__track");
    var status = root.querySelector(".neo-carousel__status");
    var dots = root.querySelector(".neo-carousel__dots");
    if (!track) return;
    var pages = carouselPages(root);
    var page = Math.min(parseInt(track.getAttribute("data-neo-page") || "0", 10), pages - 1);
    track.setAttribute("data-neo-page", String(page));
    track.style.transform = "translateX(-" + page * 100 + "%)";
    if (status) status.textContent = "Page " + (page + 1) + " of " + pages;
    if (dots) {
      if (dots.children.length !== pages) {
        dots.innerHTML = "";
        for (var i = 0; i < pages; i++) {
          var d = document.createElement("button");
          d.type = "button"; d.className = "neo-carousel__dot"; d.setAttribute("role", "tab");
          d.setAttribute("data-neo-page-to", String(i)); d.setAttribute("aria-label", "Go to page " + (i + 1));
          dots.appendChild(d);
        }
      }
      for (var j = 0; j < dots.children.length; j++) dots.children[j].setAttribute("aria-current", j === page ? "true" : "false");
    }
  }

  function carouselGo(root, delta, absolute) {
    var track = root.querySelector(".neo-carousel__track");
    if (!track) return;
    var pages = carouselPages(root);
    var page = parseInt(track.getAttribute("data-neo-page") || "0", 10);
    page = typeof absolute === "number" ? absolute : (page + delta + pages) % pages;
    track.setAttribute("data-neo-page", String(page));
    carouselRender(root);
  }

  function carouselAutoplay(root) {
    if (reduceMotion || root.getAttribute("data-neo-autoplay") === "1") return;
    root.setAttribute("data-neo-autoplay", "1");
    var timer = null, paused = false;
    function tick() { if (!paused && document.visibilityState === "visible") carouselGo(root, 1); }
    function start() { if (!timer) timer = setInterval(tick, AUTOPLAY_MS); }
    function restart() { if (timer) clearInterval(timer); timer = null; start(); }
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });
    root.addEventListener("click", restart);
    var x0 = null;
    root.addEventListener("touchstart", function (e) { paused = true; x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) carouselGo(root, dx < 0 ? 1 : -1); }
      x0 = null; paused = false; restart();
    }, { passive: true });
    start();
  }

  /* ---- Delegated clicks: FAQ accordions, carousel arrows, anchors ---- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!closest(t, ".neo-lp")) return;

    var faqBtn = closest(t, ".neo-faq-item__q");
    if (faqBtn) {
      var item = closest(faqBtn, ".neo-faq-item");
      var panel = item ? item.querySelector(".neo-faq-item__a") : null;
      var isOpen = faqBtn.getAttribute("aria-expanded") === "true";
      faqBtn.setAttribute("aria-expanded", String(!isOpen));
      if (panel) { if (isOpen) panel.setAttribute("hidden", ""); else panel.removeAttribute("hidden"); }
      return;
    }

    var arrow = closest(t, "[data-neo-carousel]");
    if (arrow) {
      var car = closest(arrow, ".neo-carousel");
      if (car) carouselGo(car, arrow.getAttribute("data-neo-carousel") === "prev" ? -1 : 1);
      return;
    }
    var dot = closest(t, "[data-neo-page-to]");
    if (dot) {
      var car2 = closest(dot, ".neo-carousel");
      if (car2) carouselGo(car2, 0, parseInt(dot.getAttribute("data-neo-page-to"), 10));
      return;
    }

    var link = closest(t, 'a[href^="#"]');
    if (link) {
      var id = link.getAttribute("href").slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top, behavior: "smooth" });
    }
  }, true);

  /* ---- Sticky bottom CTA: hide while the buy box itself is on screen -- */
  function initStickyCta() {
    var bar = document.querySelector(".neo-lp .neo-sticky-cta");
    var buybox = document.getElementById("neo-buybox");
    if (!bar || !buybox || !("IntersectionObserver" in window)) return;
    if (bar.getAttribute("data-neo-observed") === "1") return;
    bar.setAttribute("data-neo-observed", "1");
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.style.opacity = entry.isIntersecting ? "0" : "1";
        bar.style.pointerEvents = entry.isIntersecting ? "none" : "auto";
      });
    }, { threshold: 0.15 }).observe(buybox);
  }

  function init() {
    var car = document.querySelector(".neo-lp .neo-carousel");
    if (car) { carouselRender(car); carouselAutoplay(car); }
    initStickyCta();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  var resizeT = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { var c = document.querySelector(".neo-lp .neo-carousel"); if (c) carouselRender(c); }, 150);
  });
})();
